import { DownOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Dropdown, Menu } from 'antd'
import * as React from 'react'
import { FC } from 'react'

type AasmTransitionActionDropdownProps = {
  events: string[]
  gql: any
  onCompleted: (data: any) => void
  onError: (e: any) => void
  resourceID: string
  renderOption?: (option: string) => React.ReactNode
}
export const AasmTransitionActionDropdown: FC<AasmTransitionActionDropdownProps> = ({
  events,
  gql,
  onCompleted,
  onError,
  resourceID,
  renderOption,
}) => {
  const [update] = useMutation(gql, {
    onCompleted: onCompleted,
    onError: onError,
  })

  const onClick = ({ key }) => {
    update({ variables: { id: resourceID, aasmTransition: key } })
  }

  const menu = (
    <Menu onClick={onClick}>
      {events.map((event) => {
        const label = renderOption ? renderOption(event) : event.split('_').join(' ')
        return <Menu.Item key={event}>{label}</Menu.Item>
      })}
    </Menu>
  )
  return (
    <Dropdown overlay={menu}>
      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
        Actions <DownOutlined />
      </a>
    </Dropdown>
  )
}
